export const EcosytemIntegratorConstants = () => ({
    ECOSYSTEMLIST: {
        HEADER: 'Ecosystem Integrators',
    },
    ECOSYSTEMCREATION: {
        PARAGRAPH: 'Register a new ecosystem integrator with their details and assignments',
        LABEL_ONE: 'Ecosystem Integrator',
        LABEL_TWO: 'Country',
        LABEL_THREE: 'Integrator Type',
        LABEL_FOUR: 'Assigned Solutions',
        LABEL_FIVE: 'Email',
        LABEL_SIX: 'Phone Number ',
        SELECT_LABEL_ONE: 'Select country',
        SELECT_LABEL_TWO: 'Select integrator type',
        SELECT_LABEL_THREE: 'Country Code',

    },
    ECOSYSTEMVIEW: {
        HEADER: 'Ecosystem Integrator',
        TEXT_ONE: 'Ecosystem Integrator Name',
        TEXT_TWO: 'Country',
        TEXT_THREE: 'Integrator Type',
        TEXT_FOUR: 'Assigned Solution',
        TEXT_FIVE: 'Email',
        TEXT_SIX: 'Phone Number'
    },
    ECOSYSTEMDELETE: {
        TEXT_ONE:'Do you want to continue ?',
        TEXT_TWO:'This action cannot be undone.',
        BUTTON_TEXT_ONE:'Yes',
        BUTTON_TEXT_TWO:'No',
    }
})